import React from 'react';
import styles from './Separator.module.css';

const Separator = ({ widht, height, color, margin, marginB, marginT, marginL, marginR }) => {
    return (
        <div
            className={styles.separator}
            style={{
                backgroundColor: color,
                padding: `${height} ${widht}`,
                margin: margin,
                marginBottom: marginB,
                marginTop: marginT,
                marginLeft: marginL,
                marginRight: marginR
            }}
        />
    );
};

export default Separator;
